interface LogoProps {
  /** Hide the CREDISA wordmark and show only the swoosh symbol. */
  symbolOnly?: boolean;
}

/**
 * Credisa brand lockup: the gradient swoosh symbol next to the CREDISA wordmark.
 * The symbol lives in /public so it stays pixel-faithful to the brand asset; the
 * wordmark is set in the app font, tracked and weighted to match the brand guide.
 */
export function Logo({ symbolOnly = false }: LogoProps) {
  return (
    <span className="logo" aria-label="Credisa">
      <img
        className="logo-mark"
        src="/credisa-symbol.png"
        alt=""
        aria-hidden="true"
        width={28}
        height={34}
      />
      {!symbolOnly && <span className="logo-wordmark">CREDISA</span>}
    </span>
  );
}
